module.exports = __webpack_public_path__ + "img/max-person-transfer.f7b6d574.svg";